import React, { ReactNode } from "react";
import { Typography } from "antd";

interface PageHeaderProps {
  title: string;
  extra?: ReactNode;
}

/**
 * Standard page header: Typography.Title level 2 (same as the Dashboard
 * greeting) plus an optional right-aligned actions/search area, laid out in
 * the design-system flex row (space-between, centered, 16px bottom margin).
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, extra }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      // Wide search bars drop below the title instead of crushing it.
      flexWrap: "wrap",
      rowGap: 16,
      marginBottom: 16,
    }}
  >
    <Typography.Title level={2} style={{ marginBottom: 0 }}>
      {title}
    </Typography.Title>
    {extra}
  </div>
);

export default PageHeader;
